
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/authors",
      function () {
        return require("private-next-pages/blog/authors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/authors"])
      });
    }
  